const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1239.1 533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M656,196.4h30.9c17.1,0,26,2.3,31.7,6.3,9.1,5.9,14.5,17.3,14.5,29.6a36.5,36.5,0,0,1-6.2,20.8c-5.6,7.9-12.7,10.5-21.1,12l25.7,40.7H713l-30-49.4h3.9c7.5,0,16.7-.3,21.8-4.8s7.6-10.7,7.6-17.8-3.6-14.7-9.3-18.5-10.8-3.6-18.7-3.6H673.4v94.1H656Z",
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.6,270.4c.7,16.3,14.9,24.6,27,24.6s18.8-5.2,23.2-13.6h16c-3.8,8.8-9.4,15.5-16.2,19.9a40.8,40.8,0,0,1-23,6.8c-26.3,0-42.5-21.1-42.5-42.4,0-23.1,18-42.7,42.4-42.7a42.2,42.2,0,0,1,29.7,11.8c9.5,9.6,13.5,22.2,12.1,35.6Zm53.5-11.9c-.7-10.7-11.4-22.7-26.6-22.4s-25.9,11.4-26.6,22.4Z",
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.9,225.3h14.5v11.4c3.4-6.8,12.7-13.7,24.4-13.7,7.4,0,15.1,2.2,20.7,8.5,2.1,2.1,4.3,6.4,5.2,7.9a33.1,33.1,0,0,1,5.8-8c5.1-5.2,12.5-8.4,21.3-8.4s15.6,2,21.5,8.1,8.9,14.9,8.9,30.3v44.4H943.8V262c0-6.7-.9-13.3-4.4-17.9s-7.1-6.6-14.3-6.6-12.6,2.8-15.6,7.6-3.7,9.5-3.7,16.3v44.4H890.3V261.4c.2-6.6-.6-11.5-3.2-16s-7.7-7.8-15.3-7.9a16.9,16.9,0,0,0-15.2,7.8c-3,4.3-4.3,9.9-4.3,16.4v44.1H836.9Z",
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.8,265.4c0-21.4,15.8-42.4,42.9-42.4s42.9,21,42.9,42.5-15.9,42.5-42.9,42.5-42.9-20.9-42.9-42.5Zm15.4.3c0,16,12.1,27.9,27.5,27.9s27.5-11.9,27.5-28.1-12.1-28-27.5-28-27.5,11.9-27.5,28Z",
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.5,237.3H1064v-12h14.5V196.4h15.4v28.9h15.5v12h-15.5v68.5h-15.4Z",
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.9,265.4c0-21.4,15.8-42.4,42.9-42.4s42.9,21,42.9,42.5-15.9,42.5-42.9,42.5-42.9-20.9-42.9-42.5Zm15.4.3c0,16,12.1,27.9,27.5,27.9s27.5-11.9,27.5-28.1-12.1-28-27.5-28-27.5,11.9-27.5,28Z",
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.9,350.8A172.8,172.8,0,1,0,394.2,523.6,172.7,172.7,0,0,0,566.9,350.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,348.4c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,219.5,348.4c0,95.4,77.3,172.8,172.7,172.8S565,443.8,565,348.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.024390242993833
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,346c0-95.4-77.3-172.8-172.7-172.8S217.5,250.6,217.5,346s77.4,172.8,172.8,172.8S563,441.4,563,346Z",
    style: {
      fill: "#afafaf",
      opacity: 0.048780486942867
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.1,343.6c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,561.1,343.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.073170730891901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.2,341.1c0-95.4-77.4-172.7-172.8-172.7S213.6,245.7,213.6,341.1a172.8,172.8,0,0,0,345.6,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.097560974840936
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2,338.7A172.8,172.8,0,1,0,384.5,511.5C479.9,511.5,557.2,434.1,557.2,338.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.12195121878997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.3,336.3c0-95.4-77.4-172.8-172.8-172.8S209.8,240.9,209.8,336.3s77.3,172.8,172.7,172.8S555.3,431.7,555.3,336.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.146341462739004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.3,333.9c0-95.4-77.3-172.8-172.7-172.8S207.8,238.5,207.8,333.9s77.4,172.7,172.8,172.7A172.7,172.7,0,0,0,553.3,333.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.170731706688038
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.4,331.4c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,551.4,331.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.195121950637073
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.4,329A172.7,172.7,0,0,0,376.7,156.3c-95.4,0-172.8,77.3-172.8,172.7s77.4,172.8,172.8,172.8S549.4,424.4,549.4,329Z",
    style: {
      fill: "#afafaf",
      opacity: 0.219512194586107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.5,326.6c0-95.4-77.3-172.8-172.7-172.8a172.8,172.8,0,0,0,0,345.6C470.2,499.4,547.5,422,547.5,326.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.243902438535141
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.6,324.2c0-95.4-77.4-172.8-172.8-172.8S200,228.8,200,324.2s77.4,172.7,172.8,172.7S545.6,419.6,545.6,324.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.268292682484175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.6,321.7A172.8,172.8,0,1,0,370.9,494.5,172.7,172.7,0,0,0,543.6,321.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.29268292643321
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.7,319.3c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,196.2,319.3c0,95.4,77.3,172.8,172.7,172.8S541.7,414.7,541.7,319.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.317073170382244
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.7,316.9c0-95.4-77.3-172.8-172.7-172.8S194.2,221.5,194.2,316.9,271.6,489.7,367,489.7,539.7,412.3,539.7,316.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.341463414331278
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.8,314.5c0-95.4-77.4-172.8-172.8-172.8S192.3,219.1,192.3,314.5A172.7,172.7,0,0,0,365,487.2C460.4,487.2,537.8,409.9,537.8,314.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.365853658280313
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.9,312.1a172.8,172.8,0,1,0-345.6,0c0,95.4,77.4,172.7,172.8,172.7S535.9,407.5,535.9,312.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.390243902229347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.9,309.6A172.8,172.8,0,1,0,361.2,482.4C456.6,482.4,533.9,405,533.9,309.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.414634146178381
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,307.2c0-95.4-77.4-172.8-172.8-172.8S186.4,211.8,186.4,307.2,263.8,480,359.2,480,532,402.6,532,307.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.439024390127415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530,304.8C530,209.4,452.7,132,357.3,132A172.8,172.8,0,1,0,530,304.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.46341463407645
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.1,302.4A172.8,172.8,0,1,0,355.3,475.1C450.7,475.1,528.1,397.8,528.1,302.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.487804878025484
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.1,299.9A172.7,172.7,0,0,0,353.4,127.2c-95.4,0-172.8,77.3-172.8,172.7S258,472.7,353.4,472.7,526.1,395.3,526.1,299.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.512195121974518
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.2,297.5c0-95.4-77.3-172.8-172.7-172.8a172.8,172.8,0,0,0,0,345.6C446.9,470.3,524.2,392.9,524.2,297.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.536585365923552
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.3,295.1c0-95.4-77.4-172.8-172.8-172.8S176.7,199.7,176.7,295.1s77.4,172.7,172.8,172.7S522.3,390.5,522.3,295.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.560975609872587
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.3,292.7A172.8,172.8,0,1,0,347.6,465.4,172.7,172.7,0,0,0,520.3,292.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.585365853821621
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.4,290.2c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,172.9,290.2c0,95.4,77.3,172.8,172.7,172.8S518.4,385.6,518.4,290.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.609756097770655
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.4,287.8c0-95.4-77.3-172.8-172.7-172.8S170.9,192.4,170.9,287.8s77.4,172.8,172.8,172.8S516.4,383.2,516.4,287.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.634146341719689
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.5,285.4c0-95.4-77.4-172.8-172.8-172.8S169,190,169,285.4A172.7,172.7,0,0,0,341.7,458.1C437.1,458.1,514.5,380.8,514.5,285.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.658536585668724
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.5,283A172.8,172.8,0,1,0,167,283c0,95.4,77.4,172.7,172.8,172.7A172.7,172.7,0,0,0,512.5,283Z",
    style: {
      fill: "#afafaf",
      opacity: 0.682926829617758
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.6,280.5A172.8,172.8,0,1,0,337.9,453.3C433.3,453.3,510.6,375.9,510.6,280.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.707317073566792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.7,278.1c0-95.4-77.4-172.8-172.8-172.8S163.1,182.7,163.1,278.1s77.4,172.8,172.8,172.8S508.7,373.5,508.7,278.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.731707317515826
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.7,275.7c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,506.7,275.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.75609756146486
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.8,273.3A172.8,172.8,0,1,0,332,446C427.4,446,504.8,368.7,504.8,273.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.780487805413895
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.8,270.8A172.7,172.7,0,0,0,330.1,98.1c-95.4,0-172.8,77.3-172.8,172.7s77.4,172.8,172.8,172.8S502.8,366.2,502.8,270.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.804878049362929
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.9,268.4c0-95.4-77.4-172.8-172.8-172.8S155.4,173,155.4,268.4s77.3,172.8,172.7,172.8S500.9,363.8,500.9,268.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.829268293311963
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,266c0-95.4-77.4-172.8-172.8-172.8S153.4,170.6,153.4,266s77.4,172.7,172.8,172.7S499,361.4,499,266Z",
    style: {
      fill: "#afafaf",
      opacity: 0.853658537260997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,263.6A172.8,172.8,0,1,0,324.3,436.3,172.7,172.7,0,0,0,497,263.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.878048781210032
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.1,261.1c0-95.4-77.4-172.7-172.8-172.7S149.5,165.7,149.5,261.1s77.4,172.8,172.8,172.8S495.1,356.5,495.1,261.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.902439025159066
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.1,258.7c0-95.4-77.3-172.8-172.7-172.8a172.8,172.8,0,0,0,0,345.6C415.8,431.5,493.1,354.1,493.1,258.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.9268292691081
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.2,256.3c0-95.4-77.4-172.8-172.8-172.8S145.7,160.9,145.7,256.3A172.7,172.7,0,0,0,318.4,429C413.8,429,491.2,351.7,491.2,256.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.951219513057134
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.2,253.9a172.8,172.8,0,1,0-345.5,0c0,95.4,77.4,172.7,172.8,172.7A172.7,172.7,0,0,0,489.2,253.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.975609757006168
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.3,251.4A172.8,172.8,0,1,0,314.6,424.2C410,424.2,487.3,346.8,487.3,251.4Z",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.5,251.4c0-95.4-77.4-172.7-172.8-172.7S139.9,156,139.9,251.4s77.4,172.8,172.8,172.8S485.5,346.8,485.5,251.4Z",
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,334.9H253a9.7,9.7,0,0,1-9.6-9.7v-4a9.7,9.7,0,0,1,9.6-9.7h12a9.8,9.8,0,0,1,9.7,9.7v4h0A9.8,9.8,0,0,1,265,334.9Zm0-16H253a2.3,2.3,0,0,0-2.2,2.3v4a2.2,2.2,0,0,0,2.2,2.2h12a2.2,2.2,0,0,0,2.2-2.2v-4A2.3,2.3,0,0,0,265,318.9Zm5.9,6.3h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,271.4H271.5a6,6,0,0,0-6,6v61.7H369V277.4A6,6,0,0,0,363,271.4Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,252.4H301.3a15.2,15.2,0,0,0-15.2,15.2v67.6h8.7V267.6a6.5,6.5,0,0,1,6.5-6.5H401.5a6.6,6.6,0,0,1,6.6,6.5v67.6h8.7V267.6A15.3,15.3,0,0,0,401.5,252.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.9,335.3H408V267.6a6.5,6.5,0,0,0-6.5-6.4H301.3a6.4,6.4,0,0,0-6.4,6.4v67.7H286V267.6a15.4,15.4,0,0,1,15.3-15.3H401.5a15.4,15.4,0,0,1,15.4,15.3Zm-8.7-.2h8.5V267.6a15.2,15.2,0,0,0-15.2-15.1H301.3a15.2,15.2,0,0,0-15.1,15.1v67.5h8.5V267.6a6.7,6.7,0,0,1,6.6-6.6H401.5a6.7,6.7,0,0,1,6.7,6.6Z",
    style: {
      fill: "#3877bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5,338.9H226.7a3.8,3.8,0,0,1-3.7-3.7,3.7,3.7,0,0,1,3.7-3.7H412.5a3.7,3.7,0,0,1,3.7,3.7A3.8,3.8,0,0,1,412.5,338.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.6,287.2A17.5,17.5,0,1,0,368,304.7a17.4,17.4,0,0,0-17.4-17.5Zm0,26.2a8.7,8.7,0,1,1,3.3-16.8,8.7,8.7,0,0,1-3.3,16.8Zm0,0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.6,322.2A17.5,17.5,0,0,1,334.4,298a17.4,17.4,0,0,1,16.2-10.8h0a17.5,17.5,0,0,1,6.7,33.7A17.7,17.7,0,0,1,350.6,322.2Zm0-34.9a17.4,17.4,0,1,0,17.3,17.4,17.3,17.3,0,0,0-17.3-17.4Zm0,26.2h0a8.9,8.9,0,0,1-8.2-5.5,8.8,8.8,0,0,1,2-9.6,8.9,8.9,0,0,1,9.6-1.9,8.9,8.9,0,0,1-3.4,17Zm0-17.5a8.3,8.3,0,0,0-6.1,2.6,8.6,8.6,0,0,0-1.9,9.4,8.6,8.6,0,0,0,16.6-3.3,8.6,8.6,0,0,0-5.3-8A9.8,9.8,0,0,0,350.6,296Z",
    style: {
      fill: "#3877bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.4,211.4a33.5,33.5,0,1,1,33.5-33.5A33.5,33.5,0,0,1,314.4,211.4Zm0-59.6a26.1,26.1,0,1,0,26.1,26.1A26.1,26.1,0,0,0,314.4,151.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4,315.8h-.5a3.7,3.7,0,0,1-3.1-4.2l8.9-61.9a25.2,25.2,0,0,1,25.2-24.9h41A25.2,25.2,0,0,1,360.1,250v5.6a3.7,3.7,0,0,1-3.7,3.7,3.6,3.6,0,0,1-3.7-3.7V250a17.8,17.8,0,0,0-17.8-17.8h-41A17.8,17.8,0,0,0,276.1,250v.5l-9,62.2A3.7,3.7,0,0,1,263.4,315.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,141.9a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,178.8,141.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,141a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,178.1,141Z",
    style: {
      fill: "#afafaf",
      opacity: 0.024390242993833
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,140.2a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,177.5,140.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.048780486942867
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,139.4a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,176.8,139.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.073170730891901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,138.5a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,176.1,138.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.097560974840936
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,137.7a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,175.4,137.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.12195121878997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,136.9a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,174.8,136.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.146341462739004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,136a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,174.1,136Z",
    style: {
      fill: "#afafaf",
      opacity: 0.170731706688038
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.4,135.2a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,173.4,135.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.195121950637073
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,134.4a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,172.8,134.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.219512194586107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,133.5a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,172.1,133.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.243902438535141
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.4,132.7a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,171.4,132.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.268292682484175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,131.8a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,170.8,131.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.29268292643321
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,131a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,170.1,131Z",
    style: {
      fill: "#afafaf",
      opacity: 0.317073170382244
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4,130.2a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,169.4,130.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.341463414331278
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.8,129.3a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,168.8,129.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.365853658280313
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,128.5a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,168.1,128.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.390243902229347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,127.7a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,167.4,127.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.414634146178381
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7,126.8a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,166.7,126.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.439024390127415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.1,126a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,166.1,126Z",
    style: {
      fill: "#afafaf",
      opacity: 0.46341463407645
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4,125.2a59.6,59.6,0,1,0-59.5,59.5A59.6,59.6,0,0,0,165.4,125.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.487804878025484
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,124.3a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,164.7,124.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.512195121974518
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,123.5A59.6,59.6,0,1,0,104.5,183,59.6,59.6,0,0,0,164.1,123.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.536585365923552
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,122.6a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,163.4,122.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.560975609872587
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,121.8a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,162.7,121.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.585365853821621
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1,121a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,162.1,121Z",
    style: {
      fill: "#afafaf",
      opacity: 0.609756097770655
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.4,120.1a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,161.4,120.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.634146341719689
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7,119.3a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,160.7,119.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.658536585668724
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,118.5A59.6,59.6,0,1,0,100.5,178,59.5,59.5,0,0,0,160,118.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.682926829617758
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4,117.6a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,159.4,117.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.707317073566792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.7,116.8a59.6,59.6,0,1,0-59.5,59.6A59.6,59.6,0,0,0,158.7,116.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.731707317515826
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,116a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,158,116Z",
    style: {
      fill: "#afafaf",
      opacity: 0.75609756146486
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,115.1a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,157.4,115.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.780487805413895
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,114.3a59.6,59.6,0,1,0-59.5,59.5A59.6,59.6,0,0,0,156.7,114.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.804878049362929
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,113.5A59.6,59.6,0,1,0,96.5,173,59.5,59.5,0,0,0,156,113.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.829268293311963
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,112.6a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,155.4,112.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.853658537260997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,111.8a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,154.7,111.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.878048781210032
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,110.9a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,154,110.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.902439025159066
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.4,110.1a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,153.4,110.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.9268292691081
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.7,109.3a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,152.7,109.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.951219513057134
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,108.4A59.6,59.6,0,1,0,92.5,168,59.5,59.5,0,0,0,152,108.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.975609757006168
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,107.6a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,151.3,107.6Z",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3,
    cy: 106.5,
    rx: 60.6,
    ry: 61.2,
    style: {
      fill: "#007dc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,145.1A38.6,38.6,0,1,1,129,106.5,38.6,38.6,0,0,1,90.3,145.1Zm0-72.8a34.2,34.2,0,1,0,34.2,34.2A34.2,34.2,0,0,0,90.3,72.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,129.5a2.6,2.6,0,0,1-1.5-.4c-2.5-1.3-2.9-5.7-3-8.2,0-7.6-.4-13.5-5.9-15.6A66.5,66.5,0,0,0,86,103a4.7,4.7,0,0,1-3.6-4.1,7.3,7.3,0,0,1,6.7-8.3c0-.3-.1-.6-.1-1.1a2.8,2.8,0,0,0-.7-1.9c-.6-.5-2.1-.3-3.2-.2l-1.8.2h-.2c-.5.6-1,3-1.5,5.5l-.2,1.2c-.6,2.6-2,3.4-3.1,3.6s-4.1-2.3-4.4-2.9a2.2,2.2,0,0,1-.4-1.3,13.7,13.7,0,0,1-5.1,3c-2.7.9-4.1-.1-4.8-.8-2.3-2.5-.4-8.2,1-11.3a2.2,2.2,0,0,1,2.9-1.2,2.3,2.3,0,0,1,1.2,3A18.3,18.3,0,0,0,67,92.5c2.5-.9,3.2-1.8,3.3-2l.2-.4L73,85.7a2.3,2.3,0,0,1,2.5-1.1,2.2,2.2,0,0,1,1.7,2c.1,1.4.2,3,.3,4.2,1.1-4.9,2-7.7,5.8-7.7h1.2c1.9-.2,4.6-.5,6.6,1.1a6.8,6.8,0,0,1,2.3,5c.2,2.6.3,4.2-.8,5.3a3,3,0,0,1-2.7.7,2.3,2.3,0,0,0-1.4.2,3.5,3.5,0,0,0-1.6,2.1c-.1.8,0,1.2.1,1.3a65.7,65.7,0,0,1,7.5,2.5c8.8,3.3,8.8,13.1,8.8,19.6a19.8,19.8,0,0,0,.4,3.6c3-3.1,8.8-12.8,7.7-15.9-1.7-4.7-2.5-7,2.3-9.6,2.5-1.4,4-2.9,4-3.9a2.2,2.2,0,0,1,2.1-2.4,2.2,2.2,0,0,1,2.3,2.1c.2,3-1.9,5.8-6.3,8.1l-1.3.8a25.1,25.1,0,0,0,1.1,3.4c1.2,3.5-1,8.7-3.1,12.5s-5,7.9-7.1,9.3A3.5,3.5,0,0,1,103.3,129.5ZM67,93.1Zm3.2-2.3Zm0,0Zm0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,130.3h-.8a2.2,2.2,0,0,1-1.3-2.8c2.9-8.8,4.3-10.5,6.5-12.4l-1.5-.6a12.9,12.9,0,0,1-4.4-2.2,9.8,9.8,0,0,0-2.1-1.7l-.8-.4a34.4,34.4,0,0,0-1,5.8,2.2,2.2,0,0,1-4.4-.4c.8-9.3,2.8-10.2,3.6-10.5a2.8,2.8,0,0,1,2.9.4l1.9,1.3a15.1,15.1,0,0,1,3.1,2.3,17.2,17.2,0,0,0,2.7,1.3c2.5.9,4.9,1.8,5.3,4a3.4,3.4,0,0,1-1.2,3.1l-.9.7c-1.7,1.5-2.6,2.3-5.5,10.7A2.1,2.1,0,0,1,68.2,130.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.8,474.2A222.9,222.9,0,0,1,92.5,225.5c.5-3.9,1-7.8,1.7-11.6l2.2.3c-.7,3.8-1.2,7.7-1.7,11.6A220.6,220.6,0,0,0,469.8,407.4,220.6,220.6,0,0,0,175.6,79.5l-1.4-1.7A222.8,222.8,0,1,1,313.8,474.2Z",
    style: {
      fill: "#007dc3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoto);
export default __webpack_public_path__ + "static/media/remoto.63cc1aacad8b6eb4e72f3ecf29332563.svg";
export { ForwardRef as ReactComponent };